import './branding-pill.css';

interface BrandingPillProps {
  /** Primary text (left of separator) */
  primary?: string;
  /** Secondary text (right of separator) */
  secondary?: string;
  /** Separator character */
  separator?: string;
}

/**
 * BrandingPill Component
 *
 * Displays the app branding in a pill-shaped element that floats
 * at the top of the viewport as part of the vortex-centric layout.
 */
export function BrandingPill({
  primary = 'Driver',
  secondary = 'Gauge',
  separator = '|',
}: BrandingPillProps): JSX.Element {
  return (
    <div className="branding-pill">
      <span className="branding-pill__primary">{primary}</span>
      <span className="branding-pill__separator">{separator}</span>
      <span className="branding-pill__secondary">{secondary}</span>
    </div>
  );
}

export default BrandingPill;
